import { render, staticRenderFns } from "./TermsOfUse.vue?vue&type=template&id=31a96aa9&"
import script from "./TermsOfUse.vue?vue&type=script&lang=ts&"
export * from "./TermsOfUse.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports